const load = () => {
	const _body = document.getElementById('body');
	const _loader = document.getElementById('js-loader');
	let loadDelay = 0;
	let delayFlag = false;
	let loadFlag = false;

	// Load
	// ---------------------------------------------------------
	const setLoad = () => {
		if (delayFlag && loadFlag) {
			_body.setAttribute('data-load', true);
		}
	};

	if (_loader) {
		// loadDelay = interval * endCount + 200;
		loadDelay = 600;
	}

	setTimeout(() => {
		delayFlag = true;
		setLoad();
	}, loadDelay);

	window.addEventListener('load', () => {
		loadFlag = true;
		setLoad();
	});

	// Timeout
	// ---------------------------------------------------------
	if (_loader) {
		const loadTimeout = 3000;

		setTimeout(() => {
			_body.setAttribute('data-load', true);
		}, loadTimeout);
	}
};
load();
